import styled, { css } from 'styled-components';

export const Blurred = styled.div<{ $disabled?: boolean }>(
  ({ $disabled }) =>
    !$disabled &&
    css`
      filter: blur(8px);
      user-select: none;
      position: relative;
    `,
);
